export default "__VITE_ASSET__B278aYZo__"